export default {
  data: null,
  columns: [
    {
      label: '订单编号',
      prop: 'id'
    },
    {
      label: '订单日期',
      prop: 'payTime'
    },
    {
      label: '场地名称',
      prop: 'placeModeName'
    },
    {
      label: '场地ID',
      prop: 'placeModeId'
    },
    {
      label: '场地属性',
      prop: 'placeModeType'
    },
    {
        label: '场地号',
        prop: 'placeModeFieldNo'
    },
    {
        label: '日期',
        prop: 'dateTime'
    },
    {
        label: '时间段',
        prop: 'dateRange'
    },
    {
        label: '姓名',
        prop: 'userName'
    },
    {
        label: '账号',
        prop: 'account'
    },
    {
        label: '支付金额',
        prop: 'payAmount'
    },
    {
      label: '退款比例',
      prop: 'refundProportion'
    },
    {
      label: '退款金额',
      prop: 'refundMoney'
    },
    {
        label: '状态',
        prop: 'status'
    },
    {
        label: '备注',
        prop: 'remark'
    }
  ]
}
